import React, { useState } from "react";
import DeployUIII from "./DeployUIII";
import DeployUI from "./DeployUI";

const Embed = ({ userId, botId }) => {
  const [activeEmbed, setActiveEmbed] = useState("bubble");

  return (
    <div className="flex flex-col flex-1 w-full gap-4 md:p-4">
      <div className="flex flex-col w-full md:flex-row gap-4">
        <div
          onClick={() => setActiveEmbed("bubble")}
          className="p-4 border rounded-lg bg-white shadow-md w-full md:w-1/2  flex items-center justify-between  cursor-pointer hover:shadow-lg transition">
          <div>
            <h2 className="text-lg  2xl:text-2xl  font-bold mb-2">
              Embed a chat bubble{" "}
              <span className="text-primary text-sm  2xl:text-base  md:ml-2 rounded-full bg-lightprimary/50 px-3 py-1">
                Recommended
              </span>
            </h2>
            <p className="text-gray-600  2xl:text-lg ">
              Embed a chat bubble on your website. Allows you to use all the
              advanced features of the agent.
            </p>
          </div>
          <div
            className={`min-w-6 min-h-6 rounded-full border-2  flex items-center justify-center transition ${
              activeEmbed === "bubble" ? "border-primary" : "border-gray-400"
            }`}>
            {activeEmbed === "bubble" && (
              <div className="min-w-3 min-h-3 bg-primary rounded-full"></div>
            )}
          </div>
        </div>

        <div
          onClick={() => setActiveEmbed("iframe")}
          className="p-4 border rounded-lg bg-white shadow-md w-full md:w-1/2  flex items-center justify-between  cursor-pointer hover:shadow-lg transition">
          <div className="flex flex-1 h-full flex-col">
            <h2 className="text-lg 2xl:text-2xl font-bold">
              Embed the iframe directly
            </h2>
            <p className="text-gray-600  2xl:text-lg ">
              Add the agent anywhere on your website.
            </p>
          </div>
          <div
            className={`min-w-6 min-h-6 rounded-full border-2 flex items-center justify-center transition ${
              activeEmbed === "iframe" ? "border-primary" : "border-gray-400"
            }`}>
            {activeEmbed === "iframe" && (
              <div className="min-w-3 min-h-3 bg-primary rounded-full"></div>
            )}
          </div>
        </div>
      </div>
      {activeEmbed === "bubble" && <DeployUIII userId={userId} botId={botId} />}
      {activeEmbed === "iframe" && <DeployUI userId={userId} botId={botId} />}
      <div className="border border-gray-300 p-6 bg-gray-50 rounded-xl font-sans">
        <h2 className="text-xl font-semibold text-red-600 mb-4">
          ⚠️ Unable to Interact with Embedded Page
        </h2>

        <p className="mb-2">
          Your webpage is currently blocking embedding inside iframes due to a
          restrictive security header:
        </p>

        <pre className="bg-gray-200 p-3 rounded-md text-sm mb-4">
          x-frame-options: DENY
        </pre>

        <p className="mb-2">
          To resolve this and allow your site to work correctly when embedded
          (e.g., in Jaano AI), update your server's headers:
        </p>

        <h3 className="text-lg font-semibold text-green-700 mb-2">
          ✅ Recommended Fix
        </h3>
        <ol className="list-decimal list-inside space-y-2 mb-4">
          <li>
            <strong>Remove</strong> the <code>X-Frame-Options: DENY</code>{" "}
            header.
          </li>
          <li>
            <strong>Add</strong> this header:
            {/* <pre className="bg-gray-200 p-3 rounded-md text-sm mt-2">
              Content-Security-Policy: frame-ancestors https://jaano.ai/
            </pre> */}
            <div className=" bg-gray-200 p-3 rounded-md text-sm mt-2">
              Content-Security-Policy: frame-ancestors https://jaano.ai/
            </div>
          </li>
        </ol>

        <h3 className="text-lg font-semibold text-blue-700 mb-2">
          🛠️ Where to Configure
        </h3>
        <ul className="list-disc list-inside space-y-1 mb-4">
          <li>
            <strong>Apache:</strong> in <code>.htaccess</code> or site config
            using <code>Header set</code>
          </li>
          <li>
            <strong>Nginx:</strong> in <code>nginx.conf</code> using{" "}
            <code>add_header</code>
          </li>
          <li>
            <strong>Cloudflare:</strong> via <em>Rules → Response Headers</em>
          </li>
        </ul>

        <p className="text-sm text-gray-700">
          ⚠️ <strong>Important:</strong> Only allow trusted domains in{" "}
          <code>frame-ancestors</code> to avoid clickjacking attacks.
        </p>
      </div>
    </div>
  );
};

export default Embed;
